// AUTO-GENERATED BY scripts/embed-env.cjs — DO NOT EDIT.
/* eslint-disable */
export const embeddedGoogleOAuthClientId = "";
